import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  mainURL = 'genai-mic/auth/v3/connect/';
  constructor(private http: HttpClient) { }

  loginWithGoogle(user: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'login/google', user);
  }

  loginAsLinkedIn(authCode: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'login/linkedin', authCode);
  }

  loginAsUser(user: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'login/system/owner', user);
  }

  registerUser(user: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'register/user', user);
  }

  refreshAccessToken(user: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'refresh-token', user);
  }

  logoutFromGoogle(user: any) {
    return this.http.post(environment.authApiUrl + this.mainURL + 'logout', user);
  }
}
